import { ItemLink } from './item-link';
import { LinkFragment } from './types';
import styles from '../styles.module.css';

type CopyrightSectionProps = {
  copyright: LinkFragment[];
  dataPreference: string;
  showConsentModal?: VoidFunction;
  copyrightText: string;
  websiteUrl: string;
  locale: string;
};

export const CopyrightSection = ({
  copyright,
  dataPreference,
  showConsentModal,
  copyrightText,
  websiteUrl,
  locale,
}: CopyrightSectionProps) => (
  <div className={styles.copyrightWrapper}>
    <ul className={styles.termsWrapper}>
      {copyright?.map((item) => (
        <li key={item.label} className={styles.termsItem}>
          <ItemLink websiteUrl={websiteUrl} {...item} locale={locale} />
        </li>
      ))}
      <li>
        <button type="button" onClick={showConsentModal} className={styles.buttonReset}>
          {dataPreference}
        </button>
      </li>
    </ul>

    <ul>
      <li>{copyrightText}</li>
    </ul>
  </div>
);
